import { render, staticRenderFns } from "./AllMothersReport.vue?vue&type=template&id=60b74c60&scoped=true&"
import script from "./AllMothersReport.vue?vue&type=script&lang=js&"
export * from "./AllMothersReport.vue?vue&type=script&lang=js&"
import style0 from "./AllMothersReport.vue?vue&type=style&index=0&id=60b74c60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b74c60",
  null
  
)

export default component.exports